<script>
import $ from 'jquery';
require('jquery-ui');
require('jquery-ui/ui/widgets/datepicker');
import _ from 'lodash';
import axios from 'axios';
import VueScrollTo from 'vue-scrollto';

    export default {
        props: [
            'titleChoices',
            'contactTypes',
            'addressStatusChoices',
            'maritialStatusChoices',
            'employmentStatusChoices',
            'employmentBasisChoices',
            'specialisationAreaChoices',
            'occupationChoices',
            'giftFromChoices',
            'endpoint',
            'saveEndpoint',
            'existingCenseoProfile',
        ],
        data: function () {
            return {
                modal: {
                    show: false,
                    class: "",
                    icon: "",
                    title: "",
                    html: ""
                },
                showModal : false,
                sendingForm: false,
                savingForm: false,
                currentStep: 1,
                steps: {
                    1 : {
                        valid: true,
                        fields: ['application_type']
                    },
                    2 : {
                        valid: true,
                        fields: ['title', 'first_name', 'sur_name ', 'date_of_birth', 'email_address', 'mobile_number', 'means_of_contact', 'joint_title', 'joint_first_name', 'joint_sur_name', 'joint_date_of_birth', 'joint_email_address', 'joint_mobile_number','joint_means_of_contact']
                    },
                    3 : {
                        valid: true,
                        fields : ['address_line1','city','post_code','address_status','date_moved_in','previous_address_count','main_applicant_previous_addresses','joint_address_line1','joint_city','joint_post_code','joint_address_status','joint_date_moved_in','joint_previous_address_count','joint_applicant_previous_addresses','maritial_status','financial_dependant_children','main_applicant_child_dependant','financial_dependant_adult','main_applicant_adult_dependant','joint_maritial_status','joint_financial_dependant_children','joint_applicant_child_dependant','joint_financial_dependant_adult','joint_applicant_adult_dependant','is_uk_national','is_irish_citizen','is_eu_citizen','indefinite_leave','eu_settlement_scheme_leave','visa_expire','joint_is_uk_national','joint_is_irish_citizen','joint_is_eu_citizen','joint_indefinite_leave', 'joint_eu_settlement_scheme_leave' ,'joint_visa_expire','failed_regular_payments','court_judgement_registered','bankrupt','application_refused','explanation','joint_failed_regular_payments','joint_court_judgement_registered','joint_bankrupt','joint_application_refused','joint_explanation']
                    },
                    4 : {
                        valid: true,
                        fields : ['employment_status','employment_basis','specialisation_area','occupation','start_date_current_employment','probation','probation_end_date','furloughed_at_any_time ','self_assessments_available','previous_employment_count','main_applicant_previous_employments','joint_employment_status','joint_employment_basis','joint_start_date_current_employment','joint_specialisation_area','joint_occupation','joint_probation','joint_probation_end_date','joint_furloughed_at_any_time','joint_self_assessments_available','joint_previous_employment_count','joint_applicant_previous_employments','paid_in_gb_sterling','annual_basic_salary','guaranteed_annual_bonus','non_guaranteed_bonus','annual_profit_share','average_monthly_take_home','net_profit_latest','net_profit_previous','net_profit_third_year','directors_salary_latest','directors_salary_previous','directors_salary_third_year','dividend_income_latest','dividend_income_previous','dividend_income_third_year','joint_paid_in_gb_sterling','joint_annual_basic_salary','joint_guaranteed_annual_bonus','joint_non_guaranteed_bonus','joint_annual_profit_share','joint_average_monthly_take_home','joint_net_profit_latest','joint_net_profit_previous','joint_net_profit_third_year','joint_directors_salary_latest','joint_directors_salary_previous','joint_directors_salary_third_year','joint_dividend_income_latest','joint_dividend_income_previous ','joint_dividend_income_third_year','child_benefit_annum','child_tax_credit_annum','working_tax_credit_annum','disability_allowance_annum','guaranteed_maintenance_income_annum','investment_pension_annum','second_job','second_job_months','annual_income_from_second_job','joint_child_benefit_annum','joint_child_tax_credit_annum','joint_working_tax_credit_annum','joint_disability_allowance_annum','joint_guaranteed_maintenance_income_annum','joint_investment_pension_annum','joint_second_job','joint_second_job_months','joint_annual_income_from_second_job','deduction_pension ','deduction_company_pension','travel_ticket_deduction','travel_ticket_deduction_amount','student_loan_deduction','student_loan_deduction_amount','share_save_deduction','share_save_deduction_amount','childcare_vouchers','childcare_vouchers_amount','child_maintenance_payments','child_maintenance_payments_amount','childcare_payment','childcare_payment_amount','credit_store_card','main_applicant_credit_card','unsecured_loans','main_applicant_unsecured_loan','hire_lease_agreement','main_applicant_hire_lease_agreement','joint_deduction_pension','joint_deduction_company_pension','joint_travel_ticket_deduction','joint_travel_ticket_deduction_amount','joint_student_loan_deduction','joint_student_loan_deduction_amount','joint_share_save_deduction','joint_share_save_deduction_amount','joint_childcare_vouchers','joint_childcare_vouchers_amount','joint_child_maintenance_payments','joint_child_maintenance_payments_amount','joint_childcare_payment','joint_childcare_payment_amount','joint_credit_store_card','joint_applicant_credit_card','joint_unsecured_loans','joint_applicant_unsecured_loan','joint_hire_lease_agreement','joint_applicant_hire_lease_agreement','own_savings','monetary_gift','gift_from','gift-in-uk','monetary_gift_amount','joint_own_savings','joint_monetary_gift','joint_gift_from','joint_gift-in-uk', 'joint_monetary_gift_amount']
                    },
                },
                step_1_valid: false,
                step_2_valid: false,
                step_3_valid: false,
                step_4_valid: false,
                form : {
                    application_type : '',
                    title: "",
                    first_name: "",
                    sur_name : "",
                    date_of_birth: "",
                    email_address: "",
                    mobile_number: "",
                    means_of_contact: "",
                    joint_title: "",
                    joint_first_name: "",
                    joint_sur_name: "",
                    joint_date_of_birth: "",
                    joint_email_address: "",
                    joint_mobile_number: "",
                    joint_means_of_contact: "",
                    address_line1: "",
                    city: "",
                    post_code: "",
                    address_status: "",
                    date_moved_in: "",
                    previous_address_count: 0,
                    main_applicant_previous_addresses: [],
                    joint_address_line1: "",
                    joint_city: "",
                    joint_post_code: "",
                    joint_address_status: "",
                    joint_date_moved_in: "",
                    joint_previous_address_count: 0,
                    joint_applicant_previous_addresses: [],
                    maritial_status: "",
                    financial_dependant_children: 0,
                    main_applicant_child_dependant: [],
                    financial_dependant_adult: 0,
                    main_applicant_adult_dependant: [],
                    joint_maritial_status: "",
                    joint_financial_dependant_children: 0,
                    joint_applicant_child_dependant: [],
                    joint_financial_dependant_adult: 0,
                    joint_applicant_adult_dependant: [],
                    is_uk_national: "",
                    is_irish_citizen: "",
                    is_eu_citizen: "",
                    lived_in_uk: "",
                    indefinite_leave: "",
                    eu_settlement_scheme_leave: "",
                    visa_expire: "",
                    joint_is_uk_national: "",
                    joint_is_irish_citizen: "",
                    joint_is_eu_citizen: "",
                    joint_lived_in_uk: "",
                    joint_indefinite_leave: "",
                    joint_eu_settlement_scheme_leave: "",
                    joint_visa_expire: "",
                    failed_regular_payments: "",
                    court_judgement_registered: "",
                    bankrupt: "",
                    application_refused: "",
                    explanation: "",
                    joint_failed_regular_payments: "",
                    joint_court_judgement_registered: "",
                    joint_bankrupt: "",
                    joint_application_refused: "",
                    joint_explanation: "",
                    employment_status: "",
                    employment_basis: "",
                    specialisation_area: "",
                    occupation: "",
                    start_date_current_employment: "",
                    probation: "",
                    probation_end_date: "",
                    furloughed_at_any_time : "",
                    self_assessments_available: "",
                    previous_employment_count: 0,
                    main_applicant_previous_employments: [],
                    joint_employment_status: "",
                    joint_employment_basis: "",
                    joint_start_date_current_employment: "",
                    joint_specialisation_area: "",
                    joint_occupation: "",
                    joint_probation: "",
                    joint_probation_end_date: "",
                    joint_furloughed_at_any_time: "",
                    joint_self_assessments_available: "",
                    joint_previous_employment_count: 0,
                    joint_applicant_previous_employments: [],
                    paid_in_gb_sterling: "",
                    annual_basic_salary: "",
                    guaranteed_annual_bonus: "",
                    non_guaranteed_bonus: "",
                    annual_profit_share: "",
                    average_monthly_take_home: "",
                    net_profit_latest: "",
                    net_profit_previous: "",
                    net_profit_third_year: "",
                    directors_salary_latest: "",
                    directors_salary_previous: "",
                    directors_salary_third_year: "",
                    dividend_income_latest: "",
                    dividend_income_previous: "",
                    dividend_income_third_year: "",
                    joint_paid_in_gb_sterling: "",
                    joint_annual_basic_salary: "",
                    joint_guaranteed_annual_bonus: "",
                    joint_non_guaranteed_bonus: "",
                    joint_annual_profit_share: "",
                    joint_average_monthly_take_home: "",
                    joint_net_profit_latest: "",
                    joint_net_profit_previous: "",
                    joint_net_profit_third_year: "",
                    joint_directors_salary_latest: "",
                    joint_directors_salary_previous: "",
                    joint_directors_salary_third_year: "",
                    joint_dividend_income_latest: "",
                    joint_dividend_income_previous : "",
                    joint_dividend_income_third_year: "",
                    child_benefit_annum: "",
                    child_tax_credit_annum: "",
                    working_tax_credit_annum: "",
                    disability_allowance_annum: "",
                    guaranteed_maintenance_income_annum: "",
                    investment_pension_annum: "",
                    second_job: "",
                    second_job_months: "",
                    annual_income_from_second_job: "",
                    joint_child_benefit_annum: "",
                    joint_child_tax_credit_annum: "",
                    joint_working_tax_credit_annum: "",
                    joint_disability_allowance_annum: "",
                    joint_guaranteed_maintenance_income_annum: "",
                    joint_investment_pension_annum: "",
                    joint_second_job: "",
                    joint_second_job_months: "",
                    joint_annual_income_from_second_job: "",
                    deduction_pension : "",
                    deduction_company_pension: "",
                    travel_ticket_deduction: "",
                    travel_ticket_deduction_amount: "",
                    student_loan_deduction: "",
                    student_loan_deduction_amount: "",
                    share_save_deduction: "",
                    share_save_deduction_amount: "",
                    childcare_vouchers: "",
                    childcare_vouchers_amount: "",
                    child_maintenance_payments: "",
                    child_maintenance_payments_amount: "",
                    childcare_payment: "",
                    childcare_payment_amount: "",
                    credit_store_card: 0,
                    main_applicant_credit_card: [],
                    unsecured_loans: 0,
                    main_applicant_unsecured_loan: [],
                    hire_lease_agreement: 0,
                    main_applicant_hire_lease_agreement: [],
                    joint_deduction_pension: "",
                    joint_deduction_company_pension: "",
                    joint_travel_ticket_deduction: "",
                    joint_travel_ticket_deduction_amount: "",
                    joint_student_loan_deduction: "",
                    joint_student_loan_deduction_amount: "",
                    joint_share_save_deduction: "",
                    joint_share_save_deduction_amount: "",
                    joint_childcare_vouchers: "",
                    joint_childcare_vouchers_amount: "",
                    joint_child_maintenance_payments: "",
                    joint_child_maintenance_payments_amount: "",
                    joint_childcare_payment: "",
                    joint_childcare_payment_amount: "",
                    joint_credit_store_card: 0,
                    joint_applicant_credit_card: [],
                    joint_unsecured_loans: 0,
                    joint_applicant_unsecured_loan: [],
                    joint_hire_lease_agreement: 0,
                    joint_applicant_hire_lease_agreement: [],
                    own_savings: "",
                    monetary_gift: "",
                    gift_from: "",
                    'gift-in-uk': "",
                    monetary_gift_amount: "",
                    joint_own_savings: "",
                    joint_monetary_gift: "",
                    joint_gift_from: "",
                    'joint_gift-in-uk' : "",
                    joint_monetary_gift_amount: "",
                },
                validationErrors: [],
              }
        },
        mounted: function () {
            this.initDatePicker();
            this.initForm();
        },
        watch: {
            /*
            'form.application_type': function(newVal, oldVal) {
                if(newVal == 'joint') {
                    this.step_2_valid = false;
                    this.step_3_valid = false;
                    this.step_4_valid = false;
                }
            }
             */
        },
        methods: {
            initForm: function() {
                if(_.isNull(this.existingCenseoProfile.formFields)) {
                    this.form = _.mapValues(this.form, function (val, key) {
                        return (val == null) ? "" : val;
                    });
                } else {
                    let existingFields = _.mapValues(this.existingCenseoProfile.formFields, function (val, key) {
                        if(_.isArray(val)) {
                            if(val.length == 0) {
                                return [];
                            }

                            let retObj = [];
                            let counter = 0;
                            _.forEach(val, function(val2, key2) {
                                let result;
                                result = _.mapValues(val2, v => _.isNil(v) ? '' : v)
                                retObj[counter] = result;
                                counter++;
                            });
                            return retObj;
                        }
                        else {
                            return (val == null) ? "" : val;
                        }
                    });

                    _.forEach(this.form, function(value, key) {
                        if(!_.has(existingFields, key)) {
                            existingFields[key] = (value == null) ? "" : value;
                        }
                    });
                    this.form = existingFields;
                }

                this.currentStep = 1;
                this.$nextTick(() => {
                    window.initUniform();
                });

                // validate each step
                this.validateStepPromise([1,2,3,4], false)
                    .then((response) => {

                    })
                    .catch(error => {

                    })
                    .then(response => {
                    });
            },

            switchToStep: function(step) {
                this.switchToStepPromise(step);
            },

            switchToStepPromise: function(step) {
                let self = this;
                return new Promise(
                    function (resolve) {
                        self.currentStep = step;
                        resolve();
                    }
                );
            },

            initDatePicker: function() {
                var censeo_datepicker_options = {
                    dateFormat: 'dd/mm/yy',
                    firstDay: 1,
                    changeYear: true,
                    yearRange: "-100:+0",
                    showOtherMonths: true,
                    onSelect: function(dateText) {
                        $(this)[0].dispatchEvent(new Event('input', { 'bubbles': true }))
                    }
                }

                var censeo_datepicker_future_options = {
                    dateFormat: 'dd/mm/yy',
                    firstDay: 1,
                    changeYear: true,
                    yearRange: "-0:+100",
                    showOtherMonths: true,
                    onSelect: function(dateText) {
                        $(this)[0].dispatchEvent(new Event('input', { 'bubbles': true }))
                    }
                }

                $('body').on('focus',".date-chooser", function(){
                    $('.date-chooser').not('.date-future').datepicker(censeo_datepicker_options);
                    $('.date-chooser.date-future').datepicker(censeo_datepicker_future_options);
                });
            },

            addPreviousAddress: function(type) {
                this.addPreviousAddressPromise(type).then(function() {
                    window.initUniform();
                });
            },

            addPreviousAddressPromise: function(type) {
                let self = this;
                self.addingRepeaterField = true;
                return new Promise(
            function (resolve, reject) {
                        let newItem = {
                            address_line1: '',
                            city: '',
                            postcode: '',
                            status: '',
                            moved_in_date: ''
                        }

                        if(type == 'main') {
                            self.form.previous_address_count += 1;
                            self.form.main_applicant_previous_addresses.push(newItem);
                        } else if(type == 'joint') {
                            self.form.joint_previous_address_count += 1;
                            self.form.joint_applicant_previous_addresses.push(newItem);
                        }
                        self.addingRepeaterField = false;
                        resolve();
                    }
                );
            },

            addFinancialChildrenDependants: function(type) {
                this.addFinancialChildrenDependantsPromise(type).then(function() {
                    window.initUniform();
                });
            },

            addFinancialChildrenDependantsPromise: function(type) {
                let self = this;
                return new Promise(
                    function (resolve, reject) {
                        let newItem = {
                            name: '',
                            date_of_birth: '',
                        }

                        if(type == 'main') {
                            self.form.financial_dependant_children += 1;
                            self.form.main_applicant_child_dependant.push(newItem);
                        } else if(type == 'joint') {
                            self.form.joint_financial_dependant_children += 1;
                            self.form.joint_applicant_child_dependant.push(newItem);
                        }
                        resolve();
                    }
                );
            },

            addFinancialAdultDependants: function(type) {
                this.addFinancialAdultDependantsPromise(type).then(function() {
                    window.initUniform();
                });
            },

            addFinancialAdultDependantsPromise: function(type) {
                let self = this;
                return new Promise(
                    function (resolve, reject) {
                        let newItem = {
                            name: '',
                            date_of_birth: '',
                        }

                        if(type == 'main') {
                            self.form.financial_dependant_adult += 1;
                            self.form.main_applicant_adult_dependant.push(newItem);
                        } else if(type == 'joint') {
                            self.form.joint_financial_dependant_adult += 1;
                            self.form.joint_applicant_adult_dependant.push(newItem);
                        }
                        resolve();
                    }
                );
            },

            removeDependant: function(applicantType,dependantType,index ) {
                let lookupDependantArray = applicantType + '_applicant_' + dependantType + '_dependant';
                if(this.form[lookupDependantArray]) {
                    this.form[lookupDependantArray].splice(index, 1);
                    if(applicantType == 'main') {
                        if(dependantType == 'child') {
                            this.form.financial_dependant_children -= 1;
                        } else if (dependantType == 'adult') {
                            this.form.financial_dependant_adult -= 1;
                        }
                    } else if (applicantType == 'joint') {
                        if(dependantType == 'child') {
                            this.form.joint_financial_dependant_children -= 1;
                        } else if (dependantType == 'adult') {
                            this.form.joint_financial_dependant_adult -= 1;
                        }
                    }
                }
            },

            deletePreviousAddress: function(type, index) {
                if(type == 'main') {
                    this.form.previous_address_count -= 1;
                    this.form.main_applicant_previous_addresses.splice(index, 1);
                } else if(type == 'joint') {
                    this.form.joint_previous_address_count -= 1;
                    this.form.joint_applicant_previous_addresses.splice(index, 1);
                }
            },

            showExplanation: function (type) {
                let prefix = type == 'joint' ? 'joint_' : '';
                if(
                    parseInt(this.form[prefix + 'failed_regular_payments']) === 1
                    || parseInt(this.form[prefix + 'court_judgement_registered']) === 1
                    || parseInt(this.form[prefix + 'bankrupt']) === 1
                    || parseInt(this.form[prefix+ 'application_refused']) === 1
                ) {
                    return true;
                }
                return false;
            },

            showProbationPeriod: function(type) {
                let prefix = type == 'joint' ? 'joint_' : '';
                if(this.form[prefix + 'employment_status']) {
                    if(this.form[prefix + 'employment_status'].toLowerCase() == 'employed'
                        || this.form[prefix + 'employment_status'].toLowerCase() == 'professional') {
                        return true;
                    }
                }
                return false;
            },

            showProbationPeriodEnd: function(type) {
                let prefix = type == 'joint' ? 'joint_' : '';
                if(this.showProbationPeriod(type) === true && parseInt(this.form[prefix + 'probation']) == 1) {
                    return true;
                }
                return false;
            },

            showSelfAssessmentNumberOfYears: function(type) {
                let prefix = type == 'joint' ? 'joint_' : '';
                if(this.form[prefix + 'employment_status']) {
                    if(this.form[prefix + 'employment_status'].toLowerCase() == 'self-employed (sole trader)'
                        || this.form[prefix + 'employment_status'].toLowerCase() == 'self-employed (partnership)'
                        || this.form[prefix + 'employment_status'].toLowerCase() == 'self-employed (contractor)'
                        || this.form[prefix + 'employment_status'].toLowerCase() == 'director (limited company)'
                    ) {
                        return true;
                    }
                }
                return false;
            },

            showContractorAreaOfSpecialisation: function(type) {
                let prefix = type == 'joint' ? 'joint_' : '';
                if(this.form[prefix + 'employment_basis']) {
                    if(this.form[prefix + 'employment_basis'].toLowerCase() == 'contract') {
                        return true;
                    }
                }
                return false;
            },

            showOccupation: function(type) {
                let prefix = type == 'joint' ? 'joint_' : '';
                if(this.form[prefix + 'employment_basis']) {
                    if(
                        this.form[prefix + 'employment_basis'].toLowerCase() == 'permanent full time'
                        || this.form[prefix + 'employment_basis'].toLowerCase() == 'permanent part time'
                        || this.form[prefix + 'employment_basis'].toLowerCase() == 'agency'
                    ) {
                        return true;
                    }
                }
                return false;
            },

            addPreviousEmploymentInfo: function(type) {
                let self = this;
                this.addPreviousEmploymentInfoPromise(type).then(function() {
                    window.initUniform();
                });
            },

            addPreviousEmploymentInfoPromise: function(type) {
                let self = this;
                let prefix = type == 'joint' ? 'joint_' : '';
                return new Promise(
                    function (resolve, reject) {
                        let newItem = {
                            status: '',
                            self_assessments_available: '',
                            start_date: '',
                            end_date: ''
                        }

                        self.form[prefix + 'previous_employment_count'] += 1;
                        self.form[type + '_applicant_previous_employments'].push(newItem);
                        resolve();
                    }
                );
            },

            deletePreviousEmployment: function(type, index) {
                let prefix = type == 'joint' ? 'joint_' : '';
                this.form[prefix + 'previous_employment_count'] -= 1;
                this.form[type + '_applicant_previous_employments'].splice(index, 1);
            },

            showPrimaryIncomeBlock: function(type) {
                let prefix = type == 'joint' ? 'joint_' : '';
                if(this.form[prefix + 'employment_status'] !== "")  {
                    if(
                        this.form[prefix + 'employment_status'].toLowerCase() == 'retired'
                        || this.form[prefix + 'employment_status'].toLowerCase() == 'not employed'
                        || this.form[prefix + 'employment_status'].toLowerCase() == 'house person'
                        || (type == 'joint' && this.form.application_type !== 'joint')
                    ) {
                        return false;
                    } else {
                        return true;
                    }
                } else {
                    return false;
                }

                return true;
            },

            showBasicPrimaryIncomeTypes: function(type) {
                let prefix = type == 'joint' ? 'joint_' : '';
                if(this.form[prefix + 'employment_status']) {
                    if(
                        this.form[prefix + 'employment_status'].toLowerCase() == 'employed'
                        || this.form[prefix + 'employment_status'].toLowerCase() == 'professional'
                    ) {
                        return true;
                    }
                }
                return false;
            },

            showSelfEmployedPrimaryIncomeTypes: function(type) {
                let prefix = type == 'joint' ? 'joint_' : '';
                if(this.form[prefix + 'employment_status']) {
                    if(this.form[prefix + 'employment_status'].toLowerCase() == 'self-employed (sole trader)'
                        || this.form[prefix + 'employment_status'].toLowerCase() == 'self-employed (partnership)'
                        || this.form[prefix + 'employment_status'].toLowerCase() == 'self-employed (contractor)'
                    ) {
                        return true;
                    }
                }

                return false;
            },

            showDirectorPrimaryIncomeTypes: function(type) {
                let prefix = type == 'joint' ? 'joint_' : '';
                if(this.form[prefix + 'employment_status']) {
                    if(this.form[prefix + 'employment_status'].toLowerCase() == 'director (limited company)') {
                        return true;
                    }
                }
                return false;
            },

            showSecondJob: function(type) {
                return this.showPrimaryIncomeBlock();
            },

            showSecondJobFields: function(type) {
                let prefix = type == 'joint' ? 'joint_' : '';
                if(parseInt(this.form[prefix + 'second_job']) == 1) {
                    return true;
                }
                return false;
            },

            addCreditCard: function(type) {
                this.addCreditCardPromise(type).then(function() {
                    window.initUniform();
                });
            },

            addCreditCardPromise: function(type) {
                let self = this;
                let prefix = type == 'joint' ? 'joint_' : '';
                return new Promise(
                    function (resolve, reject) {
                        let newItem = {
                            outstanding_amount: '',
                            clear_balance: '',
                            monthly_payment: '',
                        }

                        self.form[prefix + 'credit_store_card'] += 1;
                        self.form[type + '_applicant_credit_card'].push(newItem);
                        resolve();
                    }
                );
            },

            removeCreditCard: function(type, index) {
                let prefix = type == 'joint' ? 'joint_' : '';
                this.form[prefix + 'credit_store_card'] -= 1;
                this.form[type + '_applicant_credit_card'].splice(index, 1);
                this.$nextTick(() => {
                    window.initUniform();
                });
            },

            addUnsecuredLoan: function(type) {
                this.addUnsecuredLoanPromise(type).then(function() {
                    window.initUniform();
                });
            },

            addUnsecuredLoanPromise: function(type) {
                let self = this;
                let prefix = type == 'joint' ? 'joint_' : '';
                return new Promise(
                    function (resolve, reject) {
                        let newItem = {
                            monthly_loan: '',
                            date_of_final_payment: ''
                        }

                        self.form[prefix + 'unsecured_loans'] += 1;
                        self.form[type + '_applicant_unsecured_loan'].push(newItem);
                        resolve();
                    }
                );
            },

            removeUnsecuredLoan: function(type, index) {
                let prefix = type == 'joint' ? 'joint_' : '';
                this.form[prefix + 'unsecured_loans'] -= 1;
                this.form[type + '_applicant_unsecured_loan'].splice(index, 1);
            },

            addHireLeaseAgreement: function(type) {
                this.addHireLeaseAgreementPromise(type).then(function() {
                    window.initUniform();
                });
            },

            addHireLeaseAgreementPromise: function(type) {
                let self = this;
                let prefix = type == 'joint' ? 'joint_' : '';
                return new Promise(
                    function (resolve, reject) {
                        let newItem = {
                            monthly_amount: '',
                            date_of_final_payment: '',
                        }

                        self.form[prefix + 'hire_lease_agreement'] += 1;
                        self.form[type + '_applicant_hire_lease_agreement'].push(newItem);
                        resolve();
                    }
                );
            },

            removeHireLeaseAgreement: function(type, index) {
                let prefix = type == 'joint' ? 'joint_' : '';
                this.form[prefix + 'hire_lease_agreement'] -= 1;
                this.form[type + '_applicant_hire_lease_agreement'].splice(index, 1);
            },

            goToStep: function(step) {
                if(this.currentStep <= step) {
                    this.validateStepPromise([this.currentStep], step);
                } else {
                    this.currentStep = step;
                    this.$nextTick(() => {
                        VueScrollTo.scrollTo('#formTop', {offset: -60});
                    });
                }

            },

            validateStepPromise: function(steps, gotoStep = false) {
                let self = this;
                self.form.validateSteps = steps;
                return new Promise(function(resolve, reject) {
                    self.sendingForm = true;
                    self.validationErrors = [];
                    axios
                        .post(self.endpoint, self.form)
                        .then((response) => {
                            if(response.data.validSteps && response.data.validSteps.length > 0) {
                                _.forEach(response.data.validSteps, function(value) {
                                    self.steps[value].valid = true;
                                });
                            }
                            if (response.data.success == true) {
                                if(_.isNumber(gotoStep) && gotoStep !== 5) {
                                    self.currentStep = gotoStep;
                                    self.$nextTick(() => {
                                        VueScrollTo.scrollTo('#formTop', {offset: -60});
                                    });
                                }
                                self.sendingForm = false;
                                resolve(response);
                            }
                        })
                        .catch(error => {
                            if (error.response.status == 422) {
                                self.validationErrors = error.response.data.errors;
                                if(gotoStep !== false) {
                                    self.$nextTick(() => {
                                        VueScrollTo.scrollTo('.has-error', {offset: -30});
                                    });
                                }
                                self.processErrors();
                                reject(error);
                            }
                            self.sendingForm = false;
                        });
                });
            },

            processErrors: function () {
                let self = this;
                if(!_.isEmpty(self.validationErrors)) {
                    _.forEach(self.validationErrors, function(value, key) {
                        if(_.includes(self.steps[1].fields, key)) {
                            self.steps[1].valid = false;
                        }
                        if(_.includes(self.steps[2].fields, key)) {
                            self.steps[2].valid = false;
                        }
                        if(_.includes(self.steps[3].fields, key)) {
                            self.steps[3].valid = false;
                        }
                        if(_.includes(self.steps[4].fields, key)) {
                            self.steps[4].valid = false;
                        }
                    });
                }
            },

            showError: function(field) {
                if(this.validationErrors[field]) {
                    return this.validationErrors[field][0];
                }
                return false;
            },

            submitForm: function() {
                let self = this;
                this.validateStepPromise([4],5).then(() => {
                    self.sendForm();
                }).catch(error => {
                    //console.log(error);
                });
            },

            saveFormToKeaze: function() {
                let self = this;
                self.sendingForm = true;
                axios
                    .post(self.saveEndpoint, self.form)
                    .then((response) => {
                        self.modal = response.data.modal;
                        self.$refs.responseModal.open();
                    })
                    .catch(error => {
                        console.log(error);
                    })
                    .then(function () {
                        self.sendingForm = false;
                    });
            },

            sendForm: function() {
                let self = this;
                self.sendingForm = true;
                self.form.toCenseo = true;
                axios.post(self.endpoint, self.form)
                    .then((response) => {
                        if(response.data.redirect) {
                            window.location.replace(response.data.redirect);
                        }
                    }).catch(error => {
                        //console.log(error);
                        if (error.response.status == 422) {
                            self.validationErrors = error.response.data.errors;
                            if(error.response.data.modal) {
                                self.modal = error.response.data.modal;
                                self.$refs.responseModal.open();
                            } else {
                                self.$nextTick(() => {
                                    VueScrollTo.scrollTo('.has-error', {offset: -30});
                                });
                            }
                        }
                        self.currentStep = 4;
                        self.sendingForm = false;
                    })
                    .then(function () {
                        self.$delete(self.form, 'toCenseo');
                    });
            },

            showButtonClass: function (step) {
                if(this.currentStep == step) {
                    return 'bg-white';
                } else if (this.steps[step].valid === true) {
                    return 'mayoral-default';
                }
                else {
                    return 'bg-none';
                }
            },
        }
    }
</script>
